import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { CourierFilesApiAdapter } from '../adapters';
import { MarkProcessedRequest } from '../models';

export const useMarkProcessed = () => {
  const { toast } = useToast();
  const { t } = useTranslation('codCourierFiles');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: MarkProcessedRequest) => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new CourierFilesApiAdapter(httpClient);
      return adapter.markProcessed(data);
    },
    onSuccess: (data) => {
      // Invalidar la query de archivos para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['courier-cod-files'] });

      toast({
        title: t('markProcessed.success.title', 'Archivos marcados como procesados'),
        description: t('markProcessed.success.description', 'Se procesaron {{files_processed}} archivo(s).', {
          files_processed: data.files_processed,
        }),
        variant: 'default',
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        t('markProcessed.error.unexpected', 'Ocurrió un error inesperado');

      toast({
        title: t('markProcessed.error.title', 'Error al marcar archivos'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });

  return {
    markProcessed: mutation.mutate,
    markProcessedAsync: mutation.mutateAsync,
    isMarking: mutation.isPending,
  };
};
